
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","viewBox":"0 0 168 38","fill":"#FFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 32.974V9.814a4 4 0 013.724-3.991l80-5.528A4 4 0 0188 4.285V14.55a4 4 0 01-3.102 3.898l-80 18.424A4 4 0 010 32.974z"}}),_c('path',{attrs:{"d":"M168 32.974V9.814a4 4 0 00-3.724-3.991l-80-5.528A4 4 0 0080 4.285V14.55a4 4 0 003.102 3.898l80 18.424A4 4 0 00168 32.974z"}})])
          )
        }
      }
    